import React, { useState, useEffect } from "react";
import styled from "styled-components";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

import { useSelector } from "react-redux";
import BASE_API_URL from "../../../../api/api";
import apiInstance from "../../../../Utils/api";
const Button = styled.button`
  background: rgb(0, 7, 51);
  color: white;
  justify-content: center;
  padding: 5px 10px;
  border: none;
  border-radius: 10px;
`;

const Create = () => {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;

  const [bankList, setBankList] = useState([]);
  const [cashList, setCashList] = useState([]);

  const [procedures, setProcedures] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [date, setDate] = useState("");
  const [reqDate, setReqDate] = useState("");
  const [remark, setRemark] = useState("");
  const [reason, setReason] = useState("");

  const [branchLists, setBranchLists] = useState([]);
  const [branch, setBranch] = useState("");
  const [branchID, setBranchID] = useState("");

  const [medicineSale, setMedicineSale] = useState([]);

  const [initialAmount, setInitialAmount] = useState("");
  const [itemList, setItemList] = useState([]);
  const [accessories, setAccessories] = useState([]);
  const [medicineList, setMedicineList] = useState([]);
  const [showMedItem, setShowMedItem] = useState(false);
  const [showProMedItem, setShowProMedItem] = useState(false);
  const [showProAccItem, setShowProAccItem] = useState(false);
  const [totalPrice, setTotalPrice] = useState("");
  const [totalQty, setTotalQty] = useState("");

  const [code, setCode] = useState("");
  const [seq, setSeq] = useState("");
  const location = useLocation();

  //Meidcine
  const [medApprQty, setMedApprQty] = useState("");
  const [medReqQty, setMedReqQty] = useState("");

  //Procedure
  const [proApprQty, setProApprQty] = useState("");
  const [proReqQty, setProReqQty] = useState("");

  //Pro Ass
  const [proAssApprAty, setProAssApprQty] = useState("");
  const [proAssReqQty, setProAssReqQty] = useState("");

  const Id = location.pathname.split("/")[2];

  //   const data = location.state.data
  //   console.log(data, 'state')

  useEffect(() => {
    const getBankLists = async () => {
      try {
        const res = await api.get("accounting-lists");

        const bank = res.data.list.filter(
          (el) =>
            el.relatedHeader.name == "Cash At Bank" &&
            el.relatedType.name === "Assets",
        );
        setBankList(bank);
      } catch (err) {}
    };
    const getAccountingLists = async () => {
      try {
        const res = await api.get("accounting-lists");
        const medicineSale = res.data.list.filter(
          (e) =>
            e.relatedHeader.name == "Adminstrative exp" &&
            "Selling and distribution expense" &&
            "Personal expense" &&
            e.relatedType.name == "Profit and Loss",
        );
        setInitialAmount(medicineSale[0].amount);
        // setFinalAmount(medicineSale[0].amount);
        setMedicineSale(medicineSale);
        // setAccountingList(res.data.list);
        // set(
        //   res.data.list.filter((e) => e.relatedHeader.name == "Current Assets")
        // );
      } catch (err) {}
    };

    const getBanks = async () => {
      try {
        const res = await api.get("suppliers");
        setSuppliers(res.data.list);
        console.log("supp");
        console.log(suppliers);
      } catch (err) {}
    };
    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };
    const getCashLists = async () => {
      try {
        const res = await api.get("accounting-lists");

        const cash = res.data.list.filter(
          (el) =>
            el.relatedHeader.name == "Cash In Hand" &&
            el.relatedType.name === "Assets",
        );
        setCashList(cash);
      } catch (err) {}
    };

    // const getPurchaseAppr = async () => {
    //   try {
    //     const res = await api.get('purchase-requ/' + Id)
    //     console.log(res.data.data, 'appr list')
    //   } catch (err) {
    //     alert(err.message)
    //   }
    // }

    const getPurchase = async () => {
      try {
        const res = await api.get("purchase-request/" + Id);
        // console.log(res.data.data[0], 'data')
        setItemList(res.data.data);
        setTotalPrice(res.data.data.totalPrice);
        setTotalQty(res.data.data.totalQTY);
        setRemark(res.data.data.remark);
        setReason(res.data.data.reason);
        setCode(res.data.data.code);
        setSeq(res.data.data.seq);

        setBranch(
          res.data.data.relatedBranch ? res.data.data.relatedBranch.name : "HO",
        );
        setBranchID(
          res.data.data.relatedBranch ? res.data.data.relatedBranch._id : "HO",
        );
        setDate(res.data.data.date ? res.data.data.date.split("T")[0] : "");
        setReqDate(
          res.data.data.requiredDate
            ? res.data.data.requiredDate.split("T")[0]
            : "",
        );

        if (res.data.data.medicineItems[0]) {
          setMedicineList(res.data.data.medicineItems);
          setShowMedItem(true);
        } else {
          setShowMedItem(false);
        }
        if (res.data.data.procedureItems[0]) {
          setProcedures(res.data.data.procedureItems);
          setShowProMedItem(true);
        } else {
          setShowProMedItem(false);
        }

        if (res.data.data.accessoryItems[0]) {
          setAccessories(res.data.data.accessoryItems);
          setShowProAccItem(true);
        } else {
          setShowProAccItem(false);
        }
        console.log(res.data.data, "list");
      } catch (err) {
        alert(err.message);
      }
    };

    getPurchase();
    // getCode()
    // getMedicine()

    // getProcedures()
    // getAccessories()
    // getPurchaseAppr()
    getCashLists();
    getBankLists();
    getBranches();
    getAccountingLists();
    getBanks();
  }, []);

  const handleMedInputChange = (event, id, field) => {
    // setMedID(id, 'med tran')
    // console.log(med, 'med tran')

    const newData = medicineList.map((data) => {
      if (data._id == id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    // console.log(newData[0], 'new data')
    setMedApprQty(newData[0].transferrQty);
    // setMedReqQty(newData[0].requestedQty)

    setMedicineList(newData);
  };

  const handleProInputChange = (event, id, field) => {
    // setMedID(id, 'med tran')
    // console.log(med, 'med tran')

    const newData = procedures.map((data) => {
      if (data._id == id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData, "new data");
    setProApprQty(newData[0].transferQty);

    setProcedures(newData);
  };

  const handleProAssInputChange = (event, id, field) => {
    // setMedID(id, 'med tran')
    // console.log(med, 'med tran')

    const newData = accessories.map((data) => {
      if (data._id == id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    // console.log(newData[0].medApprQty, 'new data')
    setProAssApprQty(newData[0].transferQty);

    setAccessories(newData);
  };

  const save = () => {
    const data = {
      relatedPurchaseRequest: Id,
      purchaseDate: date,
      requiredDate: reqDate,
      reason: reason,
      remark: remark,
      // relatedBranch: branch,
      medicineItems: medicineList,
      procedureItems: procedures,
      accessoryItems: accessories,
      totalQTY: totalQty,
      totalPrice: totalPrice,
      code: code,
      seq: seq,
    };
    if (branchID == "HO") {
    } else {
      data.relatedBranch = branchID;
    }
    // if (relatedBankAcc) data.relatedBankAccount = relatedBankAcc
    // if (relatedCashAcc) data.relatedCashAccount = relatedCashAcc
    // alert(JSON.stringify(data))
    api.post("purchase", data).then(function (response) {
      Swal.fire({
        title: "Successful!",
        text: "You Approved Purchase Data!",
        icon: "success",
        // showCancelButton: true,

        cancelButtonText: "Close",
      });
    });
  };
  return (
    <>
      {/* @include('sweet::alert') */}

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/purchase">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active"></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section class="content">
            <div class="container-fluid">
              <h5 className="font-weight-bold mt-3">Purchase Approve Detail</h5>
              <div className="row mt-3">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="p-2">
                        <div className="row">
                          <div className="col-6 form-group">
                            <label htmlFor="">Purchase Code</label>
                            <input
                              type="text"
                              className="form-control"
                              value={code}
                              disabled

                              // onChange={e => setDate(e.target.value)}
                            />
                          </div>

                          <div className="col-6 form-group">
                            <label>Branch</label>
                            <select
                              name="currency"
                              id=""
                              className="form-control mt-1"
                              onchange="convert(this.value)"
                              // placeholder='Filter By Branches'
                              onChange={(e) => setBranch(e.target.value)}
                              disabled
                            >
                              {/* <option hidden>Select Branch</option> */}
                              <option value={branchID} hidden>
                                {branch}
                              </option>

                              {branchLists.map((option) => (
                                <option value={option._id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-6">
                            <label htmlFor="">Purchase Request Date</label>
                            <input
                              type="date"
                              className="form-control"
                              value={date}
                              disabled
                              onChange={(e) => setDate(e.target.value)}
                            />
                          </div>
                          <div className="col-6">
                            <label htmlFor="">Required Date</label>
                            <input
                              type="date"
                              className="form-control"
                              value={reqDate}
                              disabled
                              onChange={(e) => setReqDate(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 mt-3">
                            <label htmlFor="">Reason</label>
                            <textarea
                              className="form-control"
                              defaultValue={reason}
                              disabled
                              onChange={(e) => setReason(e.target.value)}
                            />
                          </div>
                          <div className="col-6 mt-3">
                            <label htmlFor="">Remark</label>
                            <textarea
                              className="form-control"
                              defaultValue={remark}
                              disabled
                              onChange={(e) => setRemark(e.target.value)}
                            />
                          </div>
                        </div>

                        {showMedItem && (
                          <div className="row form-group mt-3">
                            <div className="col-10">
                              <h3>Medicine</h3>
                              <table className="table table-responsive table-hover table-borderless">
                                <thead>
                                  <tr>
                                    <th style={{ fontWeight: "400px" }}>#</th>

                                    <th style={{ fontWeight: "400px" }}>
                                      Name
                                    </th>
                                    <th>Stock Qty</th>

                                    <th style={{ fontWeight: "400px" }}>
                                      Requested Qty
                                    </th>

                                    <th style={{ fontWeight: "400px" }}>
                                      Approve Qty
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {medicineList.map((med, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      {/* <td>{med.code}</td> */}

                                      <td>
                                        {med.item_id
                                          ? med.item_id.medicineItemName
                                          : ""}
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          defaultValue={
                                            med.item_id.currentQuantity ===
                                              null && 0
                                          }
                                          disabled
                                          className="form-control"
                                        />
                                      </td>

                                      <td>
                                        <input
                                          type="number"
                                          defaultValue={med.requestedQty}
                                          disabled
                                          className="form-control"
                                        />
                                      </td>

                                      <td>
                                        <input
                                          type="number"
                                          defaultValue={
                                            itemList.relatedApprove
                                              .medicineItems[i - 1].transferQty
                                          }
                                          disabled
                                          onChange={(e) =>
                                            handleMedInputChange(
                                              e,
                                              med._id,
                                              "transferQty",
                                            )
                                          }
                                          className="form-control"
                                        />
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                        {/* NOTE Procedure Medicine */}
                        {showProMedItem && (
                          <div className="col-10 form-group mt-3">
                            <h3>Procedure Medicine</h3>
                            <table className="table table-responsive table-hover table-borderless">
                              <thead>
                                <tr>
                                  <th style={{ fontWeight: "400px" }}>#</th>

                                  <th style={{ fontWeight: "400px" }}>Name</th>
                                  <th>Stock Qty</th>

                                  <th style={{ fontWeight: "400px" }}>
                                    Requested Qty
                                  </th>

                                  <th style={{ fontWeight: "400px" }}>
                                    Approve Qty
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {procedures.map((proAssUnit, i) => (
                                  <tr>
                                    <td>{++i}</td>
                                    {/* <td>{proAssUnit.code}</td> */}

                                    <td>
                                      {proAssUnit.item_id.procedureItemName}
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={0}
                                        disabled
                                        className="form-control"
                                      />
                                    </td>

                                    <td>
                                      <input
                                        type="number"
                                        defaultValue={proAssUnit.requestedQty}
                                        disabled
                                        className="form-control"
                                      />
                                    </td>

                                    <td>
                                      <input
                                        type="number"
                                        defaultValue={
                                          itemList.relatedApprove
                                            .procedureItems[i - 1].transferQty
                                        }
                                        disabled
                                        onChange={(e) =>
                                          handleProInputChange(
                                            e,
                                            proAssUnit._id,
                                            "transferQty",
                                          )
                                        }
                                        className="form-control"
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                        {showProAccItem && (
                          <div className="col-10 form-group mt-3">
                            <h3>Procedure Accessory</h3>
                            <table className="table table-responsive table-hover table-borderless ">
                              <thead>
                                <tr>
                                  <th style={{ fontWeight: "400px" }}>#</th>

                                  <th style={{ fontWeight: "400px" }}>Name</th>
                                  <th>Stock Qty</th>

                                  <th style={{ fontWeight: "400px" }}>
                                    Requested Qty
                                  </th>

                                  <th style={{ fontWeight: "400px" }}>
                                    Approve Qty
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {accessories.map((proAssUnit, i) => (
                                  <tr>
                                    <td>{++i}</td>
                                    {/* <td>{proAssUnit.code}</td> */}

                                    <td>
                                      {proAssUnit.item_id.accessoryItemName}
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={
                                          proAssUnit.item_id.currentQuantity
                                        }
                                        disabled
                                        className="form-control"
                                      />
                                    </td>

                                    <td>
                                      <input
                                        type="number"
                                        defaultValue={proAssUnit.requestedQty}
                                        disabled
                                        className="form-control"
                                      />
                                    </td>

                                    <td>
                                      <input
                                        type="number"
                                        defaultValue={
                                          itemList.relatedApprove
                                            .accessoryItems[i - 1].transferQty
                                        }
                                        disabled
                                        onChange={(e) =>
                                          handleProAssInputChange(
                                            e,
                                            proAssUnit._id,
                                            "transferQty",
                                          )
                                        }
                                        className="form-control"
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                        <div className="row">
                          <div className="col-6 mt-3">
                            <label htmlFor="">Total Quantity</label>
                            <input
                              type="number"
                              className="form-control"
                              value={totalQty}
                              disabled
                            />
                          </div>
                          <div className="col-6 mt-3">
                            <label htmlFor="">Total Price</label>
                            <input
                              type="number"
                              className="form-control"
                              value={totalPrice}
                              disabled
                            />
                          </div>
                        </div>

                        <div className="offset-4 col-4">
                          {/* <Button className='mt-4 form-control' onClick={save}>
                            Save
                          </Button> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

    </>
  );
};

export default Create;
